/* eslint-disable no-unused-vars */
import paxios from "./paxios";
import { setupCache } from "axios-cache-adapter";

const USER_API = process.env.USER_API;

const cache = setupCache({
    debug: process.env.NODE_ENV !== "production"
});

const settings = {
    baseURL: USER_API,
    adapter: cache.adapter
};

/**
 * @type {import('axios').AxiosInstance}
 */
export const userResource = paxios.create({
    ...settings
});

export default {
    getUserActions: idToken => {
        const timestamp = Date.now();
        return userResource.get(`/actions?q=${timestamp}`, {
            headers: {
                "X-Firebase-ID-Token": idToken
            }
        });
    },
    starSynonym: (idToken, action) => {
        return userResource.post(`/thesaurus/star`, action, {
            headers: {
                "X-Firebase-ID-Token": idToken
            }
        });
    },
    voteSynonym: (idToken, action) => {
        return userResource.post(`/thesaurus/vote`, action, {
            headers: {
                "X-Firebase-ID-Token": idToken
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/services/UserService.js